import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem5 = ({ branch = "AIDS" }) => {
  const notes = [
    { title: 'Fundamentals of Deep Learning', link: `/notes/${branch.toLowerCase()}/DLD_AI` },
    { title: 'Computer Organization and Architecture', link: `/notes/${branch.toLowerCase()}/COA` },
    { title: 'Design Analysis and Algorithms', link: `/notes/${branch.toLowerCase()}/Design Analysis and Algorithms` },
    { title: 'Principles of Entrepreneurship Mindset', link: `/notes/${branch.toLowerCase()}/Principles of Entrepreneurship Mindset` },
    { title: 'Operating Systems', link: `/notes/${branch.toLowerCase()}/Operating Systems` },
    { title: 'Introduction to Internet of Things', link: `/notes/${branch.toLowerCase()}/Introduction to Internet of Things` },
    { title: 'Data Mining', link: `/notes/${branch.toLowerCase()}/Data Mining` },
  ];

  return (
    <SemesterLayout
      branch={branch}
      semester="5th Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem5;
